import Image from 'app/Components/Shared/Image/image';

import React, { useEffect, useState } from 'react';

const SubscriberPackages = (props) => {
    const [isShowUserPackages, setShowUserPackages] = useState(false);

    useEffect(() => { }, []);

    function toggleShowSubscriberPackages() {
        isShowUserPackages ? setShowUserPackages(false) : setShowUserPackages(true);
    };

    return (
        <div className='subscriber-packages-wrapper'>
            <div role='button' aria-expanded={isShowUserPackages}
                aria-controls="subscriber-packages"
                aria-label="display subscriber packages"
                className={`${isShowUserPackages ? 'open-selector' : ''} subscriber-packages-selector`} onClick={() => toggleShowSubscriberPackages()}>
                <div className='selector-right'>
                    <span className='packages-count'>{props.subscriberPackages.length}</span>
                    <div className='package-title'>חבילות הפרימיום שלך</div>
                </div>
                <Image className={isShowUserPackages ? 'arrow-toggle-up' : 'arrow-toggle-down'}
                    src={require('../../images/arrow.svg')}
                    alt='חץ' />
            </div>
            <div id='subscriber-packages' className={`${isShowUserPackages ? 'open-content' : ''}`}>
                {props.subscriberPackages.map((subscriberPackage, index) => {
                    return (<div key={index} onClick={() => props.onSelectedSubscriberPackage(subscriberPackage)} className='subscriber-package'>
                        <div className='subscriber-package-details-wrapper'>
                            <div className='package-index'>{index + 1}.</div>
                            <div className='package-details'>
                                <div className='package-name'>{subscriberPackage.name}</div>
                                <div>{subscriberPackage.description}</div>
                                {!subscriberPackage.expirationDate && <div>מנוי קבוע</div>}
                                {subscriberPackage.expirationDate && <div>מנוי חד פעמי עבור {'2'} ימים</div>}
                                {subscriberPackage.expirationDate && <div> {"מסתיים ב- " + subscriberPackage.expirationDate}</div>}
                            </div>
                        </div>
                        <div className='package-arrow'></div>
                    </div>)
                })}
            </div>
        </div>);

}
export default SubscriberPackages;
